<template>
  <router-view />
</template>

<script>
import * as Routes from './constants/routes'

export default {
  name: 'App',
  methods: {
    logout () {
      this.$store.commit('SET_USER', null)
      this.$store.commit('SET_TOKEN', null)
      this.$store.commit('SET_FIRSTNAME', null)
      this.$store.commit('SET_LASTNAME', null)
      this.$store.commit('SET_UPDATED', null)

      if (window.localStorage) {
        window.localStorage.setItem('token', null)
        window.localStorage.setItem('roleID', null)
      }

      if (window.sessionStorage) {
        window.sessionStorage.setItem('user', null)
        window.sessionStorage.setItem('firstname', null)
        window.sessionStorage.setItem('lastname', null)
        window.sessionStorage.setItem('updated', null)
      }

      this.$router.push(Routes.LOGIN)
    }
  }
}
</script>

<style>
  /* Import Simple Line Icons Set */
  $simple-line-font-path: '~simple-line-icons/fonts/';
  @import '~simple-line-icons/css/simple-line-icons.css';
  /* Import Bootstrap Vue Styles */
  @import '~bootstrap-vue/dist/bootstrap-vue.css';
</style>
<style lang="scss">
  // Import Main styles for this application
  @import '../scss/style';
</style>
